import LabelBox from "~/SalesCampaign/components/LabelBox/LabelBox";
import { type PriceData } from "~/models/PriceData";
import { NumberFormatter as NF } from "~/utils/NumberFormatter";

interface Props {
  className?: string;
  soldOut?: boolean;
  regularPrice?: PriceData | null;
  salePrice?: PriceData;
}

export const SaleDiscountIndicator = ({ soldOut, className, regularPrice, salePrice }: Props) => {
  const r = regularPrice?.value ?? 0;
  const s = salePrice?.value ?? 0;
  if (!r || !s) {
    return null;
  }
  const diff = r - s;
  if (diff <= 0) {
    return null;
  }

  const discountPercent = Math.round((diff / r) * 100);
  // TODO - Uhm, weight formatter? Let's name it differently
  const label = `-${NF.getWeightFormatterG().format(discountPercent)}%`;

  const color = soldOut ? "inactive" : "active";
  return (
    <LabelBox variant={color} className={className}>
      {label}
    </LabelBox>
  );
};
